import { useContext } from 'react';

import { CompanyRole } from 'Src/generated/graphql';

import { FeatureFlag, MeContext } from '../../MeContext';

export default function useFeatureFlag(flag: FeatureFlag) {
  const { me, metaData } = useContext(MeContext);

  if (flag === 'servicesV2' && me.companyRole === CompanyRole.Buyer) {
    return true;
  }

  return !!metaData.actions[flag];
}
